export default {
    it: {
        "go-back": "Torna indietro",
        "new-quiz": "Segnala nuovo problema tecnico",
        "torna-home": "ok! Torna in Homepage",
        "ticket-extraRequest-success": "<strong>Grazie.</strong>Abbiamo ricevuto correttamente i nuovi allegati. La ringraziamo per la collaborazione",
        "ticket-extraRequest-error": "<strong>Errore durante il caricamento dell'allegato.</strong>Riprova più tardi",
        "privacy": "Consenso per la ",
        "terms-and-conditions-not-ok": "Devi accettare prima di procedere",

    },
    en: {
        "go-back": "Go back",
        "new-quiz": "Report new technical problem",
        "torna-home": "ok! Go back to Homepage",
        "ticket-extraRequest-success": "<strong>Thank you.</strong> We have successfully received the new attachments. We thank you for your cooperation",
        "ticket-extraRequest-error": "<strong> Error loading attachment..</strong>Try later",
        "privacy": "Consent for ",
        "terms-and-conditions-not-ok": "You must agree before submitting",

    }
}